export const SpeechBubble = {
  transclude: true,

  bindings: {
    isAnswer: '<',
  },

  template: `
    <div class="speech-bubble-row">
      <label class="speech-bubble"
        ng-class="{
          'question': !$ctrl.isAnswer,
          'answer theme-mid text-white': $ctrl.isAnswer
        }"
        ng-transclude>
      </label>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/SpeechBubble/SpeechBubble.js